import { administrationRequests } from "api/administrationApi";
import { GRADING_SCALES } from "utils/constants";
import { createExporter } from "utils/createExporter";

export const GradingScalesExporter = createExporter(
  `${GRADING_SCALES}.xlsx`,
  [
    { key: "name", label: "заглавие" },
    { key: "maxPoints", label: "максимален брой точки" },
    { key: "direction", label: "направление" },
    { key: "department", label: "катедра" },
  ],
  record => ({
    ...record,
    direction: record.direction?.name,
    department: record.department?.name,
  }),
  [
    {
      source: "directionId",
      target: administrationRequests.getDirectionsSelect(),
      name: "direction",
    },
    {
      source: "departmentId",
      target: administrationRequests.getDepartmentsSelect(),
      name: "department",
    },
  ],
);
